<template>
  <deals-view :category="category" :filters="{ anyChildOf: cid }"></deals-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { computed, reactive } from "vue";
import DealsView from "@/client/applications/justopp/views/Deals.vue";

export default {
  components: {
    DealsView,
  },
  layout: reactive({
    component: "default",
    params: {
      title: "justopp.dealsByParentCategory.pageTitleWithNoData",
      titleParams: {},
      subTitle: "justopp.dealsByParentCategory.pageSubtitle",
      //   containerClass: "margin-remove-vertical",
    },
  }),
  middleware: {
    requireUser: {},
  },
  props: {
    cid: {
      type: String,
      default: false,
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.deals.browserTitle",
  data() {
    return {
      category: false,
      asyncData: {
        category: {
          target: computed(() => `justopp/categories/${this.cid}`),
          options: {
            dataMutator: (input) => {
              if (input && input.item) {
                return input.item;
              } else {
                return false;
              }
            },
          },
        },
      },
    };
  },
  computed: {

  },
  watch: {
    category(newVal) {
      let layoutConf = this[config.layoutAccessorKey]();
      layoutConf.params.title = "justopp.dealsByParentCategory.pageTitle";
      layoutConf.params.titleParams = { categoryName: newVal.name };
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
